import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Header from "../component/Header";
import useApp from "../context/AppContext";
import { PedidoCompra } from "../types";

const DadosAdicionaisDoc = () => {
  const { usuario, showModalMessage, setUsuario, pedidos,loaded } = useApp();
  const navigate = useNavigate();
  const [dadosAdicionais, setDadosAdicionais] = useState("");
  const [dataVencimento, setDataVencimento] = useState("");
  const [showHelp, setShowHelp] = useState(false);
  const [pedidosNota, setPedidosNota] = useState<PedidoCompra[]>([]);

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    const user = { ...usuario };

    if (dataVencimento === "") showModalMessage("Selecione o Vencimento", <h2>É necessário selecionar a data de Vencimento.</h2>);
    else {
      if (user.novoDocumento) {
        user.novoDocumento.dadosAdicionais = dadosAdicionais;
        user.novoDocumento.vencimento = dataVencimento;
        setUsuario(user);
        navigate("/resumoNota");
      }
    }
    event.preventDefault();
  };

  useEffect(() => {
    usuario?.novoDocumento?.dadosAdicionais && setDadosAdicionais(usuario?.novoDocumento?.dadosAdicionais);
    usuario?.novoDocumento?.vencimento && setDataVencimento(usuario?.novoDocumento?.vencimento.toString());
    let peds: PedidoCompra[] = [];
    pedidos && pedidos
      .map((ped) => {
        if (usuario.novoDocumento?.itens?.find((item) => item.idPedido === ped.idPedido)) 
          peds.push(ped);
        return true         
      });
    setPedidosNota(peds)
  }, [usuario,pedidos,loaded]);
  const PedidosInfos = (pedido: PedidoCompra) => {
    return (
      <span>
        <b>PEDIDO DE COMPRA</b>: Nº {pedido.idPedido}
        {pedido.contrato && (
          <span>
            {" "}
            - <b>CONTRATO</b>: {pedido.contrato}
          </span>
        )}
        {pedido.inicioMedicao && pedido.fimMedicao && (
          <span>
            {" "}
            - <b>MEDIÇÃO</b>: {pedido.inicioMedicao}/{pedido.fimMedicao}
          </span>
        )}
        {pedido.processo && (
          <span>
            {" "}
            - <b>PROCESSO</b>: {pedido.processo}
          </span>
        )}
        <br />
      </span>
    );
  };
  return (
    <div className="limiter altbg4">
      <div className="container-interna">
        <div className="wrap-interna p-t-25 p-b-20">
          <Header />
          <div className="insere-fatura-etp3-wrap">
            <form onSubmit={handleSubmit}>
              <h1 className="text-center pb-5">Inserir {usuario.novoDocumento?.tipo}</h1>

              <div className="form-group">
                <h4 className="mb-2">Pedidos Selecionados&nbsp;</h4>
                {pedidosNota.map((pedido) => PedidosInfos(pedido))}
                <br />
              </div>
              <div className="form-group">
                <label className="mb-2">Dados Adicionais&nbsp;</label>
                <div className="popup circulo_interrogacao"
                          onClick={() => {
                            setShowHelp(!showHelp);
                          }}>
                  ?
                  <span className={`popuptext ${showHelp ? "show" : ""}`} id="myPopup1">
                    Campo para informações complementares.
                  </span>
                </div>
                <textarea
                  className="form-control"
                  rows={5}
                  value={dadosAdicionais}
                  onChange={(e) => setDadosAdicionais(e.currentTarget.value)}
                ></textarea>
              </div>
              <div className="form-group">
                <label className="mb-1 mt-4">Data Vencimento</label>
                <input
                  className="form-control"
                  type="date"
                  value={dataVencimento}
                  onChange={(e) => setDataVencimento(e.currentTarget.value)}
                />
              </div>

              <div className="bot-inserir-fatura mt-5 d-flex flex-row-reverse">
                <button type="submit" className="btn btn-primary">
                  Avançar
                </button>
                <button className="btn btn-secondary" onClick={() => navigate("/inserirItensDocumento")}>
                  Voltar
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};
export default DadosAdicionaisDoc;
